import { apiRoutes } from '../../api-routes';
import { epApiUrl } from '../../constants';
import { type AxiosRequestConfig, publicHttpClient } from '../../util';
import type { Feature } from './types';

export interface PlaceNearbyData {
  source: string;
  items: Feature[];
}

export type PlaceNearbyParams = {
  'point.lat': number;
  'point.lon': number;
};

export const getPlaceNearbyFn = async (
  params: PlaceNearbyParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<PlaceNearbyData>(
    epApiUrl + apiRoutes.place.nearby,
    {
      params,
      ...config,
    }
  );

  return response.data;
};
